import { render } from "./Earnings.vue?vue&type=template&id=577b0f0b&ts=true"
import script from "./Earnings.vue?vue&type=script&lang=ts"
export * from "./Earnings.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\proyectos_repositorio_institucional\\ed4\\ed4Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__